import type { EditorAPI } from '#packages/editorAPI';
import { biLogger } from '#packages/util';
import {
  editorNotificationAppear,
  mobileNoReparenting as mobileNoReparentingEvent,
} from '@wix/bi-logger-editor-data/v2';
import { getRestrictedZones } from './store';
import type { CompRef } from '@wix/document-services-types';

const MULTIPLE_VALUE_CONST = 'Multiple';

function mobileNoReparenting({
  editorAPI,
  selectedComp,
}: {
  editorAPI: EditorAPI;
  selectedComp: CompRef[];
}) {
  const targetContainers = getRestrictedZones();

  if (!targetContainers.length) {
    return;
  }

  const hasMultipleContainers = targetContainers.length > 1;
  const firstContainerCompRef = targetContainers[0].compRef;

  const targetParentBi = {
    target_parent_component_id: hasMultipleContainers
      ? MULTIPLE_VALUE_CONST
      : firstContainerCompRef.id,
    target_parent_component_type: hasMultipleContainers
      ? MULTIPLE_VALUE_CONST
      : editorAPI.components.getType(firstContainerCompRef),
  };

  selectedComp.forEach((comp) => {
    const [compBiParams] = editorAPI.bi.getComponentsBIParams([comp]);

    biLogger.report(
      mobileNoReparentingEvent({
        ts: Date.now(),
        ...compBiParams,
        ...targetParentBi,
      }),
    );
  });
}

function notificationAppear(topic: string) {
  biLogger.report(
    editorNotificationAppear({
      topic,
      origin: 'no_reparenting',
      type: 'info',
    }),
  );
}

export const reportBi = {
  mobileNoReparenting,
  notificationAppear,
};
